import React from "react";
// import { SearchIcon } from "./Icons";
import { RiTimerLine } from '@remixicon/react'

function SearchBar() {
  return (
    <div className="flex flex-col gap-1 w-80 max-sm:w-full">
      <div className="flex gap-2 items-center bg-gray-100 rounded-lg h-[38px]" style={{ cursor: `no-drop !important` }}>
        <div className="flex flex-1 gap-2 items-center px-3 py-2 rounded-lg">
          {/* <SearchIcon /> */}
          <span className="flex-1 text-sm leading-6 text-gray-400">Seek</span>
          <RiTimerLine className="text-gray-400 w-4 h-4" />
        </div>
      </div>
    </div>
  );
}

export default SearchBar;
